const conversions = [
    { 'key': 'KMToMile', 'name': 'Minutes Per KM To Mile', conversion: 1.60934, 'destination': 'Mile' },
    { 'key': 'MileToKM', 'name': 'Minutes Per Mile To KM', conversion: 1 / 1.60934, 'destination': 'KM' },
];

export default conversions